
import { createWebHistory, createRouter } from "vue-router";
import Login from "./components/Login.vue";
import AppStorageService from "./services/app-storage.service";

// Lazy-loaded part
const Home = () => import("./components/Home.vue")
const TachographNew = () => import("./components/Tachograph-New.vue")
const Profile = () => import("./components/Profile.vue")
const ConsultActivity = () => import("./components/ConsultActivity.vue")
const ConsultCounter = () => import("./components/ConsultCounter.vue")
const DriverMonitoring = () => import("./components/MapMonitoring.vue")
const ManageActivity = () => import("./components/ManageActivity.vue")
const ManageAgency = () => import("./components/ManageAgency.vue")
const ManageCompany = () => import("./components/ManageCompany.vue")
const ManageRole = () => import("./components/ManageRole.vue")
const ManageUser = () => import("./components/ManageUser.vue")
const ManageVehicle = () => import("./components/ManageVehicle.vue")
const ManageDevice = () => import("./components/ManageDevice.vue")
const ManageSim = () => import("./components/ManageSim.vue")
const ManageCalendar = () => import("./components/ManageCalendar.vue")
const ManagePayroll = () => import("./components/ManagePayroll.vue")
const ManageExpenses = () => import("./components/ManageExpenses.vue")
const CompanyPage = () => import("./components/Company.vue")
const AgencyPage = () => import("./components/Agency.vue")
const DriverPage = () => import("./components/Driver.vue")
const VehiclePage = () => import("./components/Vehicle.vue")
const ReportPage = () => import("./components/Report.vue")
const Utilitaire = () => import("./components/Utilitaire.vue")
const FileIntegration = () => import("./components/FileIntegration.vue")
const TachographFiles = () => import("./components/TachographFiles.vue")

const LOGIN_PATH = "/login";
const HOME_PATH = "/home";

function getDefaultRoute() {
  return AppStorageService.hasUser() ? HOME_PATH : LOGIN_PATH;
}

// All routes in the application
const routes = [
  {path: "/",redirect: () => getDefaultRoute(),},
  {path: "/home",name: "home",component: Home,},
  {path: "/login",name: "login",component: Login,},
  {path: "/company",name: "company",component: CompanyPage,},
  {path: "/agency",name: "agency",component: AgencyPage,},
  {path: "/driver",name: "driver",component: DriverPage,},
  {path: "/vehicle",name: "vehicle",component: VehiclePage,},
  {path: "/tachograph",name: "tachograph",component: TachographNew,},
  {path: "/profile",name: "profile",component: Profile,},
  {path: "/consultActivity",name: "consultActivity",component: ConsultActivity,},
  {path: "/consultCounter",name: "consultCounter",component: ConsultCounter,},
  {path: "/driverMonitoring",name: "driverMonitoring",component: DriverMonitoring,},
  {path: "/manageActivity",name: "manageActivity",component: ManageActivity,},
  {path: "/manageAgency",name: "manageAgency",component: ManageAgency,},
  {path: "/manageCompany/:id?",name: "manageCompany",component: ManageCompany,},
  {path: "/manageRole",name: "manageRole",component: ManageRole,},
  {path: "/manageUser",name: "manageUser",component: ManageUser,},
  {path: "/manageVehicle",name: "manageVehicle",component: ManageVehicle,},
  {path: "/manageDevice",name: "manageDevice",component: ManageDevice,},
  {path: "/manageSim",name: "manageSim",component: ManageSim,},
  {path: "/manageCalendar",name: "manageCalendar",component: ManageCalendar,},
  {path: "/managePayroll",name: "managePayroll",component: ManagePayroll,},
  {path: "/manageExpenses",name: "manageExpenses",component: ManageExpenses,},
  {path: "/report",name: "report",component: ReportPage,},
  {path: "/administration",name: "administration",component: Utilitaire,},
  {path: "/file-integration",name: "fileIntegration",component: FileIntegration,},
  {path: "/tachograph-files",name: "tachographFiles",component: TachographFiles,},
  {path: "/:pathMatch(.*)*",redirect: () => getDefaultRoute()}
];

const router = createRouter({history: createWebHistory(),routes,});
export default router;

// Management of public and private pages
router.beforeEach((to, from, next) => {
  const publicPages = new Set(["login"]);
  const authRequired = !publicPages.has(to.name);
  const loggedIn = AppStorageService.hasUser();
  // Trying to access a restricted page and not logged in
  if (authRequired && !loggedIn) {
    next(LOGIN_PATH); // Redirect to login page
  } else if (to.name === "login" && loggedIn) {
    next(HOME_PATH);
  } 
  // Trying to access a restricted page and logged in
  else {
    next(); // Redirect to the requested page
  }
});
